/**
 * Marker base class for a command payload that is NOT an entity (ADR-016, feature plan 0054).
 *
 * A payload class extends this and marks every field the backend reads with `@Expose()`; the
 * generic path in `TransformerHelper` then serializes it with
 * `instanceToPlain(payload, {excludeExtraneousValues: true})` — no hand-written transformer.
 *
 * The opt-in is deliberate: the generic path still THROWS for an entity that arrives without its
 * change-tracking proxy (ADR-015), for an object literal, an array or `null`. A structural check such
 * as "has a constructor other than Object" would let exactly those through silently.
 *
 * Fields are assigned in the constructor body (`this.css = css`), never as decorated constructor
 * parameters — `@Expose()` on a parameter is called as a parameter decorator with the wrong name.
 */
export abstract class CommandPayload {
}
